/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workspace: NonNullable<unknown> }} Learn_Jointeamtitle2Inputs */

const zh_learn_jointeamtitle2 = /** @type {(inputs: Learn_Jointeamtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加入 ${i?.workspace}`)
};

const en_learn_jointeamtitle2 = /** @type {(inputs: Learn_Jointeamtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join ${i?.workspace}`)
};

const es_learn_jointeamtitle2 = /** @type {(inputs: Learn_Jointeamtitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unirse a ${i?.workspace}`)
};

/**
* | output |
* | --- |
* | "Join {workspace}" |
*
* @param {Learn_Jointeamtitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_jointeamtitle2 = /** @type {((inputs: Learn_Jointeamtitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Jointeamtitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_jointeamtitle2(inputs)
	if (locale === "en") return en_learn_jointeamtitle2(inputs)
	return es_learn_jointeamtitle2(inputs)
});
export { learn_jointeamtitle2 as "learn_joinTeamTitle" }